import '@ant-design/v5-patch-for-react-19';
import React from 'react';
import './App.css';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import { customTheme } from './theme/theme';
import { BannersProvider } from './context/banners';
import { ModalProvider } from './context/modal';
import { AppLayout } from './components/UI/app-layout';
import { GlobalBannerModal } from './components/global-banner-modal';
import { FormProvider } from './context/form';
import { ProtectedRoute } from './hooks/protected-route';
import { SettingsProvider } from './context/settings';
import { useAuthContext } from './context/auth';

const App: React.FC = () => {
  const { isLoggedIn } = useAuthContext();

  return (
    <BrowserRouter>
      <ConfigProvider theme={customTheme}>
        {isLoggedIn ? (
          <SettingsProvider>
            <ModalProvider>
              <BannersProvider>
                <FormProvider>
                  <div className='App'>
                    <Routes>
                      <Route path='/' element={<AppLayout />} />

                      <Route
                        path='/create-asset'
                        element={
                          <ProtectedRoute requiresBannerCreation={true}>
                            <AppLayout />
                          </ProtectedRoute>
                        }
                      />

                      <Route path='/library/*' element={<AppLayout />} />

                      <Route
                        path='/creativity-form/:creativityType'
                        element={
                          <ProtectedRoute requiresBannerCreation={true}>
                            <AppLayout />
                          </ProtectedRoute>
                        }
                      />

                      <Route path='*' element={<Navigate to='/' replace />} />
                    </Routes>
                    <GlobalBannerModal />
                  </div>
                </FormProvider>
              </BannersProvider>
            </ModalProvider>
          </SettingsProvider>
        ) : (
          <div className='App'>
            <Routes>
              <Route path='*' element={<AppLayout />} />
            </Routes>
          </div>
        )}
      </ConfigProvider>
    </BrowserRouter>
  );
};

export default App;
